module.exports = __webpack_public_path__ + "img/Revolut.626eeff4.png";